let commonTree = require('./additional-tree');

const TREE_BASE_PATH = ['order', 'addParams', 'mapClasses', 'tree'];
const ORIGINAL_DATA_PATH = ['order', 'originalParameters', 'mapClasses'];
const PROPERTY_NAME = 'MapClass';

module.exports = {
    initTreeState (args, state) {
        commonTree.initTreeState(args, state, ORIGINAL_DATA_PATH, TREE_BASE_PATH)
    },

    changeValue (args, state) {
        commonTree.changeValue(args, state, ORIGINAL_DATA_PATH, TREE_BASE_PATH, PROPERTY_NAME)
    },

    setAll (args, state)
    {
        commonTree.setAll(args, state, ORIGINAL_DATA_PATH, TREE_BASE_PATH, PROPERTY_NAME)
    },

    tryUnsetSelected(args, state) {
        commonTree.tryUnsetSelected(args, state, ORIGINAL_DATA_PATH, TREE_BASE_PATH, PROPERTY_NAME)
    },

    clearFilter (args, state) {
        commonTree.clearFilter(args, state, TREE_BASE_PATH, 'mapClasses')
    },
};




// WEBPACK FOOTER //
// ./actions/custom-order/map-classes.js